import { Button, Checkbox, CustomModal, LoadingSpinner } from '@components/tailwind';
import { CustomModalRef } from '@components/tailwind/CustomModal';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import PersonalizationItem from './PersonalizationItem';
import ActiveVariant from './ActiveVariant';
import ItemPricing from './ItemPricing';
import ProductAvailability from '@components/tailwind/ProductAvailability';
import { Views } from '..';
import { getPersonalizationBreakdown } from './ItemInfo';
import { formatCurrency } from '@utils/formatters.util';
import { useSelector } from 'react-redux';
import { ButtonVariants } from '@components/tailwind/Button';

type Props = {
  className?: string;
  title?: string | React.ReactNode;
  children: React.ReactNode;
  confirmText?: string;
  confirmVariant?: ButtonVariants;
  rejectText?: string;
  rejectVariant?: ButtonVariants;
  onConfirm: () => void;
  onReject: () => void;
};

type ForwardedRefs = {
  openModal: () => void;
  closeModal: () => void;
};

const ConfirmModal: React.ForwardRefRenderFunction<ForwardedRefs, Props> = (
  {
    className = '',
    title,
    children,
    confirmText = 'OK',
    confirmVariant = 'primary',
    rejectText = 'Cancel',
    rejectVariant = 'warning',
    onConfirm,
    onReject,
  },
  forwardedRef
) => {
  const customModalRef = useRef<CustomModalRef>(null);

  useImperativeHandle(
    forwardedRef,
    () => ({
      openModal: customModalRef.current.openModal,
      closeModal: customModalRef.current.closeModal,
    }),
    [customModalRef]
  );

  return (
    <CustomModal
      ref={customModalRef}
      id='ConfirmModal'
      title={title}
      size='sm'
      defaultShown={false}
      className={className}>
      {children}
      <div>
        <Button variant={confirmVariant} onClick={onConfirm}>
          {confirmText}
        </Button>{' '}
        <Button variant={rejectVariant} onClick={onReject}>
          {rejectText}
        </Button>
      </div>
    </CustomModal>
  );
};

const ForwardedConfirmModal = forwardRef(ConfirmModal);
export type ConfirmModalRef = React.ElementRef<typeof ForwardedConfirmModal>;

export default ForwardedConfirmModal;
